import request from '@Sys~/api/request'
import { apiUrl, type } from './env'
import store from '@Sys~/store'

const gateUrl = apiUrl.gateUrl

function ajax_fn(url, data, method, header) {
  header.header_username = encodeURI(store.getters.realName); // realName
  return request({
    headers: header,
    baseURL: gateUrl,
    url: url,
    method: method,
    params: method == 'GET'? data : '',
    data: method != 'GET' ? data : '',
    withCredentials: false
  })
}

//元数据管理模块
//获取元数据列表
export function queryBy_searchForm(data) {
  return ajax_fn("/systemConfig/list", data, "GET", {})
}
//根据表单新增
export function update_byForm(data) {
  return ajax_fn("/systemConfig/update", data, "post", {})
}

